import { useMutation, useQueryClient } from 'react-query';

import { usersKey } from '../../key';
import { axiosInstance } from '../../base';

const apiUrl = '/users';

const deleteUser = async (requestData) => {
  const response = await axiosInstance.delete(`${apiUrl}/${requestData.rid}`);
  return response;
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries(usersKey.all);
    },
  });
};
